import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessageModule } from 'primeng/message';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StepsModule } from 'primeng/steps';
import { TabViewModule } from 'primeng/tabview';

@NgModule({


	imports: [

		CommonModule,
        ButtonModule,
        CalendarModule,
        CheckboxModule,
        ChipModule,
        ChipsModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        MessageModule,
        RadioButtonModule,
        SelectButtonModule,
        StepsModule,
        TabViewModule

	],

	exports: [

        ButtonModule,
        CalendarModule,
        CheckboxModule,
        ChipsModule,
        ChipModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        MessageModule,
        RadioButtonModule,
        StepsModule,
        SelectButtonModule,
        TabViewModule

	],

})
export class PrimeNgModule { }
